(() => {
  'use strict';
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  const body = document.body;
  const moneyFormat = () => $('meta[name="shop-money-format"]')?.content || '${{amount}}';
  const money = (cents, format=moneyFormat()) => {
    const n = Number(cents || 0) / 100;
    const standard = n.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2});
    const noDecimals = Math.round(n).toLocaleString();
    return String(format)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,standard.replace('.',','))
      .replace(/\{\{\s*amount\s*\}\}/g,standard);
  };
  const norm = s => String(s || '').trim().toLowerCase().replace(/\s+/g,' ');
  const escapeHtml = str => String(str || '').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[c]));
  const unique = arr => [...new Set(arr.filter(Boolean))];

  // Opening screen: three pulses, once per browsing session, then straight into the store.
  const loader = $('[data-entry-loader]');
  if (loader) {
    const seen = sessionStorage.getItem('unlabelledEntrySeen') === '1';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (seen) loader.remove();
    else {
      sessionStorage.setItem('unlabelledEntrySeen','1');
      const duration = reduced ? 250 : parseInt(getComputedStyle(loader).getPropertyValue('--entry-duration'),10) || 1800;
      setTimeout(()=>loader.classList.add('is-leaving'), Math.max(0,duration-260));
      setTimeout(()=>loader.remove(), duration+40);
    }
  }

  // Menu
  const menu = $('[data-menu]');
  let menuReturn = null;
  const openMenu = () => {
    if(!menu) return;
    menuReturn=document.activeElement;
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden','false');
    body.classList.add('is-locked');
    $('[data-menu-open]')?.setAttribute('aria-expanded','true');
    $('[data-menu-close]',menu)?.focus();
  };
  const closeMenu = () => {
    if(!menu) return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden','true');
    body.classList.remove('is-locked');
    $('[data-menu-open]')?.setAttribute('aria-expanded','false');
    menuReturn?.focus?.();
  };
  $('[data-menu-open]')?.addEventListener('click',openMenu);
  $('[data-menu-close]')?.addEventListener('click',closeMenu);
  $$('.menu-overlay__nav a').forEach(a=>a.addEventListener('click',closeMenu));

  // Bag drawer - uses Shopify's live cart, never a fake cart state.
  const drawer = $('[data-cart-drawer]');
  const scrim = $('[data-drawer-scrim]');
  const drawerBody = $('[data-cart-body]');
  const drawerFooter = $('[data-cart-footer]');
  const subtotal = $('[data-cart-subtotal]');
  const shippingProgress = $('[data-shipping-progress]');
  let cartLabels = {};
  try { cartLabels = JSON.parse($('[data-cart-labels]')?.textContent || '{}'); } catch(e) { console.error(e); }

  async function getCart(){
    const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});
    if(!r.ok) throw new Error('Cart unavailable');
    return r.json();
  }
  async function changeLine(key, quantity){
    const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
    if(!r.ok) throw new Error('Could not update bag');
    return r.json();
  }
  function updateCount(cart){ $$('[data-cart-count]').forEach(el=>el.textContent=cart.item_count); }
  function updateShippingProgress(cart){
    if(!shippingProgress)return;
    const threshold=Number(shippingProgress.dataset.thresholdCents||0), message=$('[data-shipping-message]',shippingProgress), bar=$('[data-shipping-bar]',shippingProgress);
    const remaining=Math.max(0,threshold-Number(cart.total_price||0));
    const percent=threshold>0?Math.min(100,Math.round((Number(cart.total_price||0)/threshold)*100)):100;
    if(bar)bar.style.width=`${percent}%`;
    if(message)message.textContent=remaining>0?`ADD ${money(remaining)} FOR FREE SHIPPING`:'FREE SHIPPING UNLOCKED';
  }
  function renderCart(cart){
    updateCount(cart);
    updateShippingProgress(cart);
    if(!drawerBody) return;
    if(!cart.items.length){
      const account = cartLabels.showAccount && cartLabels.accountsEnabled
        ? `<p class="drawer-account">Have an account? <a href="${cartLabels.accountUrl}">Log in</a> to check out faster.</p>` : '';
      drawerBody.innerHTML=`<div class="drawer-empty"><h3>${escapeHtml(cartLabels.empty || 'YOUR BAG IS EMPTY')}</h3><a class="button button--dark" href="/collections/all">${escapeHtml(cartLabels.continue || 'CONTINUE SHOPPING')}</a>${account}</div>`;
      if(drawerFooter) drawerFooter.hidden=true;
      return;
    }
    if(drawerFooter) drawerFooter.hidden=false;
    if(subtotal) subtotal.textContent=money(cart.total_price);
    drawerBody.innerHTML=cart.items.map(item=>`
      <div class="drawer-line" data-line="${item.key}">
        <a class="drawer-line__image" href="${item.url}">${item.image?`<img src="${item.image}" alt="">`:''}</a>
        <div class="drawer-line__info">
          <a href="${item.url}"><h4>${escapeHtml(item.product_title)}</h4></a>
          ${item.variant_title&&item.variant_title!=='Default Title'?`<p>${escapeHtml(item.variant_title)}</p>`:''}
          <p>${money(item.final_line_price)}</p>
          <div class="qty-control">
            <button type="button" data-qty="${item.quantity-1}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-qty="${item.quantity+1}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <button type="button" class="drawer-remove" data-qty="0">REMOVE</button>
      </div>`).join('');
    $$('[data-line]',drawerBody).forEach(line=>$$('[data-qty]',line).forEach(btn=>btn.addEventListener('click',async()=>{
      btn.disabled=true;
      try{renderCart(await changeLine(line.dataset.line,Number(btn.dataset.qty)));}
      catch(e){console.error(e);}
      finally{btn.disabled=false;}
    })));
  }
  async function refreshCart(){
    try{renderCart(await getCart());}
    catch(e){if(drawerBody)drawerBody.innerHTML='<p>Could not load your bag. Please refresh.</p>';console.error(e);}
  }
  async function openCart(){
    if(!drawer)return;
    await refreshCart();
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
    scrim?.classList.add('is-open'); body.classList.add('is-locked');
    $('[data-cart-open]')?.setAttribute('aria-expanded','true'); $('[data-cart-close]')?.focus();
  }
  function closeCart(){
    drawer?.classList.remove('is-open'); drawer?.setAttribute('aria-hidden','true');
    scrim?.classList.remove('is-open'); body.classList.remove('is-locked');
    $('[data-cart-open]')?.setAttribute('aria-expanded','false');
  }
  $('[data-cart-open]')?.addEventListener('click',openCart);
  $('[data-cart-close]')?.addEventListener('click',closeCart);
  scrim?.addEventListener('click',closeCart);

  // Collection controls
  document.addEventListener('change', e=>{
    if(e.target.matches('[data-sort-select]')){
      const u=new URL(location.href); u.searchParams.set('sort_by',e.target.value); location.href=u.toString();
    }
    if(e.target.matches('[data-hide-soldout]')){
      $$('[data-product-card]').forEach(card=>card.hidden=e.target.checked&&card.dataset.available!=='true');
    }
  });

  // Product card data and image carousel. The full ordered media array comes from Shopify.
  const productCache = new WeakMap();
  function getProduct(card){
    if(productCache.has(card)) return productCache.get(card);
    const node=$('[data-product-data]',card); if(!node) return null;
    try { const p=JSON.parse(node.textContent); productCache.set(card,p); return p; }
    catch(e){ console.error('UNLABELLED product data error',e); return null; }
  }
  function colorIndex(p){ return (p.options||[]).findIndex(o=>/colou?r/i.test(o.name)); }
  const canonColor = value => norm(value).replace(/gray/g,'grey').replace(/^navy$/,'royal blue');
  const sameColor = (a,b) => canonColor(a)===canonColor(b);
  function swatchHex(value){
    const c=canonColor(value);
    if(c.includes('black')) return '#111111';
    if(c.includes('white')||c.includes('cream')||c.includes('ivory')) return '#f4f1e9';
    if(c.includes('royal blue')||c.includes('navy')) return '#252b3a';
    if(c.includes('dark grey')||c.includes('charcoal')) return '#565754';
    if(c.includes('flower grey')||c.includes('grey')) return '#c9cacc';
    if(c.includes('brown')) return '#5d4637';
    if(c.includes('beige')||c.includes('taupe')) return '#b9ad9e';
    return '#a7a7a3';
  }
  function availableCardColors(p){
    const fromMedia=[];
    (p.orderedMedia||[]).forEach(item=>{
      if(typeof item!=='object'||!item?.color)return;
      if(!fromMedia.some(existing=>sameColor(existing,item.color))) fromMedia.push(item.color);
    });
    if(fromMedia.length) return fromMedia;
    const ci=colorIndex(p);
    return ci>=0 ? unique((p.options?.[ci]?.values||[]).filter(Boolean)) : [];
  }
  function defaultCardColor(p){
    const colors=availableCardColors(p);
    return colors.find(c=>canonColor(c)==='black') || colors[0] || '';
  }
  function selectedCardColor(card,p){
    const colors=availableCardColors(p);
    let selected=card.dataset.selectedColor || '';
    if(!selected || (colors.length&&!colors.some(c=>sameColor(c,selected)))) selected=defaultCardColor(p);
    if(selected) card.dataset.selectedColor=selected;
    return selected;
  }
  function cardMedia(p,card){
    const ordered=(p.orderedMedia||[]).filter(Boolean);
    const selected=card ? selectedCardColor(card,p) : '';
    if(ordered.length){
      const hasMappedColors=ordered.some(item=>typeof item==='object'&&item?.color);
      if(hasMappedColors && selected){
        const filtered=ordered.filter(item=>typeof item==='object'&&item?.src&&sameColor(item.color,selected)).map(item=>item.src);
        if(filtered.length) return unique(filtered);
      }
      const all=ordered.map(item=>typeof item==='string'?item:item?.src).filter(Boolean);
      if(all.length) return unique(all);
    }
    return unique([p.primaryFront,p.primaryBack,...(p.media||[]).map(m=>m.src)]);
  }
  function partnerIndex(p,index,length){
    if(length<2) return index;
    if(p?.verifiedPairs){
      if(index%2===0) return Math.min(index+1,length-1);
      return index-1;
    }
    return (index+1)%length;
  }
  function preloadMedia(urls){
    unique(urls).forEach(src=>{ if(!src)return; const img=new Image(); img.decoding='async'; img.src=src; });
  }
  function renderCardSwatches(card,p){
    const wrap=$('[data-card-swatches]',card); if(!wrap)return;
    const colors=availableCardColors(p);
    if(colors.length<=1){wrap.innerHTML='';wrap.hidden=true;return;}
    wrap.hidden=false;
    const selected=selectedCardColor(card,p);
    const buttons=colors.map(color=>{
      const active=sameColor(color,selected);
      return `<button class="product-swatch${active?' is-selected':''}" type="button" data-card-color="${encodeURIComponent(color)}" style="--swatch:${swatchHex(color)}" aria-label="Show ${escapeHtml(color)}" title="${escapeHtml(color)}" aria-pressed="${active}"><span aria-hidden="true"></span></button>`;
    }).join('');
    wrap.innerHTML=`<span class="product-card__colour-name">${escapeHtml(selected)}</span><span class="product-card__swatch-list">${buttons}</span>`;
  }
  function paintCardPrice(card,p){
    const el=$('[data-card-price]',card); if(!el||!Array.isArray(p.variants)||!p.variants.length)return;
    const ci=colorIndex(p), selected=selectedCardColor(card,p);
    let variants=p.variants;
    if(ci>=0&&selected) variants=variants.filter(v=>sameColor(v.options?.[ci],selected));
    if(!variants.length) variants=p.variants;
    const prices=variants.map(v=>Number(v.price)).filter(Number.isFinite);
    if(!prices.length)return;
    const min=Math.min(...prices),max=Math.max(...prices),available=variants.some(v=>v.available);
    el.textContent=`${min!==max?'FROM ':''}${money(min)}${available?'':' — SOLD OUT'}`;
  }
  function paintCard(card){
    const p=getProduct(card); if(!p) return;
    renderCardSwatches(card,p);
    const media=cardMedia(p,card); if(!media.length) return;
    let index=Number(card.dataset.cardIndex||0);
    index=((index%media.length)+media.length)%media.length;
    card.dataset.cardIndex=String(index);
    const pi=partnerIndex(p,index,media.length);
    const front=$('.product-card__face--front img',card);
    const back=$('.product-card__face--back img',card);
    const color=selectedCardColor(card,p);
    if(front){front.src=media[index];front.alt=`${p.title}${color?` — ${color}`:''} image ${index+1}`;}
    if(back){back.src=media[pi];back.alt=`${p.title}${color?` — ${color}`:''} image ${pi+1}`;}
    const count=$('[data-card-count]',card); if(count)count.textContent=`${index+1}/${media.length}`;
    card.classList.toggle('has-multiple-media',media.length>1);
    card.classList.toggle('is-verified-pair',Boolean(p.verifiedPairs));
    paintCardPrice(card,p);
    preloadMedia([media[pi],media[(index+1)%media.length],media[(index-1+media.length)%media.length]]);
  }
  function moveCard(card,delta){
    const p=getProduct(card); if(!p)return;
    const media=cardMedia(p,card); if(media.length<=1)return;
    card.dataset.cardIndex=String(Number(card.dataset.cardIndex||0)+delta);
    paintCard(card);
  }
  $$('[data-product-card]').forEach(card=>{
    const p=getProduct(card);
    if(p) card.dataset.selectedColor=defaultCardColor(p);
    paintCard(card);
    const stage=$('[data-card-stage]',card);
    if(!stage)return;
    let touchX=null,touchY=null;
    stage.addEventListener('touchstart',e=>{const t=e.touches?.[0];if(!t)return;touchX=t.clientX;touchY=t.clientY;},{passive:true});
    stage.addEventListener('touchend',e=>{
      if(touchX===null)return;
      const t=e.changedTouches?.[0]; if(!t)return;
      const dx=t.clientX-touchX,dy=t.clientY-touchY; touchX=touchY=null;
      if(Math.abs(dx)>42&&Math.abs(dx)>Math.abs(dy)*1.2){card.dataset.suppressOpen='1';moveCard(card,dx<0?1:-1);setTimeout(()=>delete card.dataset.suppressOpen,220);}
    },{passive:true});
    stage.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();moveCard(card,-1);}if(e.key==='ArrowRight'){e.preventDefault();moveCard(card,1);}});
  });

  // Quick shop
  const quick = $('[data-quick-shop]');
  const quickScrim=$('[data-quick-scrim]');
  const quickImg=$('[data-quick-image]');
  const quickTitle=$('[data-quick-title]');
  const quickPrice=$('[data-quick-price]');
  const quickOptions=$('[data-quick-options]');
  const quickDesc=$('[data-quick-description]');
  const quickSizeGuide=$('[data-quick-size-guide]');
  const quickSizeGuideContent=$('[data-quick-size-guide-content]');
  const quickAdd=$('[data-quick-add]');
  const quickMsg=$('[data-quick-message]');
  const quickCount=$('[data-quick-count]');
  const quickPrev=$('[data-quick-prev]');
  const quickNext=$('[data-quick-next]');
  const quickView=$('[data-quick-view]');
  const quickAddLabel=quick?.dataset.addLabel||'ADD TO BAG';
  const quickSoldLabel=quick?.dataset.soldLabel||'SOLD OUT';
  let quickProduct=null, selectedOptions=[], currentVariant=null, quickReturn=null, opening=false, quickMedia=[], quickMediaIndex=0;

  function mappedEntry(p){
    const ci=colorIndex(p); const color=ci>=0?norm(selectedOptions[ci]):''; const map=p.mediaMap||{};
    return map[color] || (color.includes('gray')?map[color.replace('gray','grey')]:null) || (color.includes('grey')?map[color.replace('grey','gray')]:null) || null;
  }
  function buildQuickMedia(){
    if(!quickProduct) return [];
    const mapped=mappedEntry(quickProduct);
    if(mapped?.front||mapped?.back) return unique([mapped.front,mapped.back]);
    const ordered=(quickProduct.orderedMedia||[]).map(m=>typeof m==='string'?m:m?.src).filter(Boolean);
    if(ordered.length) return unique(ordered);
    return unique([currentVariant?.featured_image?.src,quickProduct.primaryFront,quickProduct.primaryBack,...(quickProduct.media||[]).map(m=>m.src),quickProduct.featuredImage]);
  }
  function findVariant(){
    if(!quickProduct) return null;
    return quickProduct.variants.find(v=>selectedOptions.every((val,i)=>v.options[i]===val)) || null;
  }
  function setOption(index,value){
    selectedOptions[index]=value;
    currentVariant=findVariant();
    if(!currentVariant){
      currentVariant=quickProduct.variants.find(v=>v.available && v.options[index]===value) || quickProduct.variants.find(v=>v.options[index]===value) || quickProduct.variants[0];
      if(currentVariant) selectedOptions=currentVariant.options.slice();
    }
    quickMediaIndex=0;
    renderQuick();
  }
  function renderQuickOptions(){
    if(!quickOptions||!quickProduct)return;
    const ci=colorIndex(quickProduct);
    quickOptions.innerHTML=quickProduct.options.map((opt,i)=>`<fieldset class="quick-option${i===ci?' quick-option--color':''}"><legend>${escapeHtml(opt.name)}${i===ci&&selectedOptions[i]?` <span class="quick-option__current">— ${escapeHtml(selectedOptions[i])}</span>`:''}</legend><div>${opt.values.map(v=>{
      const selected=selectedOptions[i]===v;
      const exists=quickProduct.variants.some(variant=>variant.options[i]===v);
      if(i===ci) return `<button type="button" class="quick-swatch${selected?' is-selected':''}" data-quick-option="${i}" data-value="${encodeURIComponent(v)}" style="--swatch:${swatchHex(v)}" aria-label="${escapeHtml(v)}" title="${escapeHtml(v)}" aria-pressed="${selected}" ${exists?'':'disabled'}><span aria-hidden="true"></span></button>`;
      return `<button type="button" class="quick-pill${selected?' is-selected':''}" data-quick-option="${i}" data-value="${encodeURIComponent(v)}" aria-pressed="${selected}" ${exists?'':'disabled'}>${escapeHtml(v)}</button>`;
    }).join('')}</div></fieldset>`).join('');
    $$('[data-quick-option]',quickOptions).forEach(btn=>btn.addEventListener('click',()=>setOption(Number(btn.dataset.quickOption),decodeURIComponent(btn.dataset.value))));
  }
  function paintQuickMedia(){
    quickMedia=buildQuickMedia();
    if(!quickMedia.length){if(quickImg)quickImg.removeAttribute('src');return;}
    quickMediaIndex=((quickMediaIndex%quickMedia.length)+quickMedia.length)%quickMedia.length;
    if(quickImg){quickImg.src=quickMedia[quickMediaIndex];quickImg.alt=`${quickProduct.title} image ${quickMediaIndex+1}`;}
    if(quickCount)quickCount.textContent=quickMedia.length>1?`${quickMediaIndex+1} / ${quickMedia.length}`:'';
    [quickPrev,quickNext].forEach(btn=>{if(btn){btn.disabled=quickMedia.length<=1;btn.hidden=quickMedia.length<=1;}});
  }
  function renderQuick(){
    if(!quickProduct)return;
    currentVariant=findVariant() || currentVariant || quickProduct.variants[0];
    if(currentVariant && selectedOptions.length!==quickProduct.options.length) selectedOptions=currentVariant.options.slice();
    if(quickTitle)quickTitle.textContent=quickProduct.title;
    if(quickPrice)quickPrice.textContent=money(currentVariant?.price||0);
    if(quickAdd){quickAdd.disabled=!currentVariant?.available;quickAdd.textContent=currentVariant?.available?quickAddLabel:quickSoldLabel;}
    if(quickDesc||quickSizeGuideContent){
      const holder=document.createElement('div');
      holder.innerHTML=quickProduct.description||'';
      const tables=Array.from(holder.querySelectorAll('table'));
      if(quickSizeGuide&&quickSizeGuideContent){
        if(tables.length){
          quickSizeGuideContent.innerHTML=tables.map(t=>t.outerHTML).join('');
          quickSizeGuide.hidden=false;
          tables.forEach(t=>t.remove());
        }else{
          quickSizeGuideContent.innerHTML='';
          quickSizeGuide.hidden=true;
        }
      }
      if(quickDesc)quickDesc.innerHTML=holder.innerHTML;
    }
    if(quickView)quickView.href=quickProduct.url||'#';
    renderQuickOptions();
    paintQuickMedia();
  }
  function chooseInitialVariant(p,preferredColor=''){
    const ci=colorIndex(p); let v=null;
    if(ci>=0&&preferredColor) v=p.variants.find(x=>x.available&&sameColor(x.options[ci],preferredColor)) || p.variants.find(x=>sameColor(x.options[ci],preferredColor));
    if(!v&&ci>=0) v=p.variants.find(x=>x.available&&canonColor(x.options[ci])==='black');
    return v || p.variants.find(x=>x.available) || p.variants[0];
  }
  function openQuick(card){
    if(!quick||opening)return;
    opening=true; setTimeout(()=>opening=false,250);
    quickProduct=getProduct(card); if(!quickProduct){opening=false;return;}
    quickReturn=document.activeElement;
    currentVariant=chooseInitialVariant(quickProduct,card.dataset.selectedColor||'');
    selectedOptions=currentVariant?.options?.slice()||[];
    quickMediaIndex=0;
    if(quickMsg)quickMsg.textContent='';
    renderQuick();
    quick.classList.add('is-open'); quick.setAttribute('aria-hidden','false');
    quickScrim?.classList.add('is-open'); body.classList.add('is-locked');
    $('[data-quick-close]')?.focus();
  }
  function closeQuick(){
    if(!quick)return;
    quick.classList.remove('is-open'); quick.setAttribute('aria-hidden','true');
    quickScrim?.classList.remove('is-open'); body.classList.remove('is-locked');
    quickReturn?.focus?.();
  }
  document.addEventListener('click',e=>{
    const swatch=e.target.closest('[data-card-color]');
    if(swatch){
      e.preventDefault();e.stopPropagation();
      const card=swatch.closest('[data-product-card]'); if(!card)return;
      card.dataset.selectedColor=decodeURIComponent(swatch.dataset.cardColor||'');
      card.dataset.cardIndex='0';
      paintCard(card);
      return;
    }
    const prev=e.target.closest('[data-card-prev]');
    const next=e.target.closest('[data-card-next]');
    if(prev||next){
      e.preventDefault();e.stopPropagation();
      const card=e.target.closest('[data-product-card]'); if(!card)return;
      moveCard(card,prev?-1:1); return;
    }
    const opener=e.target.closest('[data-quick-open]');
    if(opener){const card=opener.closest('[data-product-card]'); if(card){e.preventDefault();if(card.dataset.suppressOpen==='1')return;openQuick(card);}}
  });
  $('[data-quick-close]')?.addEventListener('click',closeQuick);
  quickScrim?.addEventListener('click',closeQuick);
  quickPrev?.addEventListener('click',()=>{if(quickMedia.length>1){quickMediaIndex--;paintQuickMedia();}});
  quickNext?.addEventListener('click',()=>{if(quickMedia.length>1){quickMediaIndex++;paintQuickMedia();}});
  const quickMediaStage=$('[data-quick-media]');
  if(quickMediaStage){
    let qx=null,qy=null;
    quickMediaStage.addEventListener('touchstart',e=>{const t=e.touches?.[0];if(!t)return;qx=t.clientX;qy=t.clientY;},{passive:true});
    quickMediaStage.addEventListener('touchend',e=>{if(qx===null)return;const t=e.changedTouches?.[0];if(!t)return;const dx=t.clientX-qx,dy=t.clientY-qy;qx=qy=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.2&&quickMedia.length>1){quickMediaIndex+=dx<0?1:-1;paintQuickMedia();}},{passive:true});
  }
  quickAdd?.addEventListener('click',async()=>{
    if(!currentVariant?.available)return;
    quickAdd.disabled=true; quickAdd.textContent='ADDING…'; if(quickMsg)quickMsg.textContent='';
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:currentVariant.id,quantity:1}]})});
      if(!r.ok){const e=await r.json().catch(()=>({description:'Could not add item.'}));throw new Error(e.description||'Could not add item.');}
      closeQuick(); await openCart();
    }catch(e){if(quickMsg)quickMsg.textContent=e.message;}
    finally{renderQuick();}
  });

  // Product page: live variant sync + AJAX add, native Shopify form remains fallback if JS fails.
  const productRoot=$('[data-product-root]');
  if(productRoot){
    const mainImage=$('.product-main-image',productRoot);
    const thumbs=$$('[data-thumb]',productRoot);
    thumbs.forEach(btn=>btn.addEventListener('click',()=>{
      if(mainImage){mainImage.src=btn.dataset.image;mainImage.alt=btn.dataset.alt||mainImage.alt;}
      thumbs.forEach(b=>b.classList.toggle('is-active',b===btn));
    }));
    const form=$('[data-product-form]',productRoot), variantInput=$('[data-page-variant-id]',productRoot), priceEl=$('[data-page-price]',productRoot), addBtn=$('[data-page-add]',productRoot), variantsNode=$('[data-page-variants]',productRoot), mediaOrderNode=$('[data-page-media-order]',productRoot), mediaMapNode=$('[data-page-media-map]',productRoot);
    let pageVariants=[],pageMediaOrder=[],pageMediaMap={};
    try{pageVariants=JSON.parse(variantsNode?.textContent||'[]');}catch(e){console.error('UNLABELLED variant data error',e);}
    try{pageMediaOrder=JSON.parse(mediaOrderNode?.textContent||'[]');}catch(e){console.error('UNLABELLED media order error',e);}
    try{pageMediaMap=JSON.parse(mediaMapNode?.textContent||'{}');}catch(e){console.error('UNLABELLED media map error',e);}
    const currency=productRoot.dataset.currency||'AUD';
    const pageAddLabel=productRoot.dataset.addLabel||'ADD TO BAG', pageSoldLabel=productRoot.dataset.soldLabel||'SOLD OUT', pageUnavailableLabel=productRoot.dataset.unavailableLabel||'UNAVAILABLE', pageChooseLabel=productRoot.dataset.chooseLabel||'CHOOSE A SIZE';
    const sizeGroup=$('[data-size-group]',form), statusEl=$('[data-product-status]',form);
    const formatPageMoney=cents=>{try{return new Intl.NumberFormat(undefined,{style:'currency',currency}).format((Number(cents)||0)/100);}catch(e){return ((Number(cents)||0)/100).toFixed(2);}};
    const selectedPageOptions=()=>{const groups=[];$$('fieldset.product-option',form).forEach(fs=>{const checked=$('input[type="radio"]:checked',fs);groups.push(checked?.value||'');});return groups;};
    const pageColorIndex=()=>$$('fieldset.product-option',form).findIndex(fs=>/colou?r/i.test($('legend',fs)?.textContent||''));
    $$('[data-page-color-swatch]',form).forEach(label=>label.style.setProperty('--swatch',swatchHex(label.dataset.pageColorSwatch)));
    const pageMappedMedia=opts=>{
      const ci=pageColorIndex(); if(ci<0)return null;
      const color=norm(opts[ci]);
      return pageMediaMap[color] || (color.includes('gray')?pageMediaMap[color.replace('gray','grey')]:null) || (color.includes('grey')?pageMediaMap[color.replace('grey','gray')]:null) || null;
    };
    const canonicalUrl=u=>String(u||'').split('?')[0];
    const reorderProductThumbs=()=>{
      const wrap=$('.product-thumbs',productRoot); if(!wrap||!pageMediaOrder.length)return;
      const buttons=$$('[data-thumb]',wrap),byUrl=new Map(buttons.map(b=>[canonicalUrl(b.dataset.image),b]));
      pageMediaOrder.forEach(item=>{const btn=byUrl.get(canonicalUrl(item?.src));if(btn)wrap.appendChild(btn);});
      buttons.filter(b=>!pageMediaOrder.some(item=>canonicalUrl(item?.src)===canonicalUrl(b.dataset.image))).forEach(b=>wrap.appendChild(b));
    };
    reorderProductThumbs();
    const syncPageVariant=()=>{
      if(!pageVariants.length||!variantInput)return null;
      const opts=selectedPageOptions();
      let variant=pageVariants.find(v=>Array.isArray(v.options)&&v.options.every((o,i)=>String(o)===String(opts[i])));
      if(!variant&&pageVariants.length===1)variant=pageVariants[0];
      if(!variant){
        variantInput.value='';
        if(addBtn){addBtn.disabled=false;addBtn.setAttribute('aria-disabled','true');addBtn.textContent=sizeGroup&&!$('input:checked',sizeGroup)?pageChooseLabel:pageUnavailableLabel;}
        return null;
      }
      variantInput.value=variant.id;
      if(priceEl)priceEl.textContent=formatPageMoney(variant.price);
      if(addBtn){addBtn.disabled=!variant.available;addBtn.setAttribute('aria-disabled',variant.available?'false':'true');addBtn.textContent=variant.available?pageAddLabel:pageSoldLabel;}
      const ci=pageColorIndex();
      const colorName=$('[data-page-color-name]',form);
      if(colorName&&ci>=0) colorName.textContent=opts[ci]?` — ${opts[ci]}`:'';
      const mapped=pageMappedMedia(opts), fi=variant.featured_image;
      const target=mapped?.front || fi?.src || pageMediaOrder[0]?.src;
      if(target&&mainImage){mainImage.src=target;mainImage.alt=`${productRoot.querySelector('h1')?.textContent||'Product'} front`;thumbs.forEach(b=>b.classList.toggle('is-active',canonicalUrl(b.dataset.image)===canonicalUrl(target)));}
      return variant;
    };
    $$('input[type="radio"]',form).forEach(r=>r.addEventListener('change',syncPageVariant));
    syncPageVariant();
    form?.addEventListener('submit',async e=>{
      const variant=syncPageVariant();
      if(!variant?.available){
        e.preventDefault();
        if(statusEl)statusEl.textContent=sizeGroup&&!$('input:checked',sizeGroup)?'Choose your size before adding to bag.':'This combination is unavailable.';
        if(sizeGroup&&!$('input:checked',sizeGroup)){$('input',sizeGroup)?.focus();}
        return;
      }
      e.preventDefault();
      if(statusEl)statusEl.textContent='';
      if(addBtn){addBtn.disabled=true;addBtn.textContent='ADDING…';}
      try{
        const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});
        if(!r.ok){const err=await r.json().catch(()=>({description:'Could not add item.'}));throw new Error(err.description||'Could not add item.');}
        await openCart();
      }catch(err){console.error(err);if(statusEl)statusEl.textContent=err.message||'Could not add item. Please try again.';}
      finally{syncPageVariant();}
    });
  }

  $$('[data-campaign-carousel]').forEach(carousel=>{
    const track=$('[data-campaign-track]',carousel),slides=$$('[data-campaign-slide]',carousel),previous=$('[data-campaign-previous]',carousel),next=$('[data-campaign-next]',carousel),count=$('[data-campaign-count]',carousel);
    if(!track||slides.length<2)return;
    const mobile=matchMedia('(max-width: 749px)'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
    let index=0,timer=null,startX=null;
    const visible=()=>mobile.matches?1:3;
    const maximum=()=>Math.max(0,slides.length-visible());
    const paint=nextIndex=>{
      const max=maximum();
      index=nextIndex>max?0:nextIndex<0?max:nextIndex;
      track.style.transform=`translate3d(-${index*(100/visible())}%,0,0)`;
      slides.forEach((slide,slideIndex)=>slide.setAttribute('aria-hidden',slideIndex<index||slideIndex>=index+visible()?'true':'false'));
      if(count)count.textContent=`${String(index+1).padStart(2,'0')} / ${String(max+1).padStart(2,'0')}`;
    };
    const stop=()=>{if(timer){clearInterval(timer);timer=null;}};
    const start=()=>{stop();if(!reduced.matches&&maximum()>0)timer=setInterval(()=>paint(index+1),Math.max(3000,Number(carousel.dataset.speed)||5000));};
    previous?.addEventListener('click',()=>{paint(index-1);start();});
    next?.addEventListener('click',()=>{paint(index+1);start();});
    carousel.addEventListener('mouseenter',stop);
    carousel.addEventListener('mouseleave',start);
    carousel.addEventListener('focusin',stop);
    carousel.addEventListener('focusout',start);
    carousel.addEventListener('pointerdown',event=>{if(!event.target.closest('button'))startX=event.clientX;});
    carousel.addEventListener('pointerup',event=>{if(startX===null)return;const distance=event.clientX-startX;startX=null;if(Math.abs(distance)>45){paint(index+(distance<0?1:-1));start();}});
    carousel.addEventListener('keydown',event=>{if(event.key==='ArrowLeft')paint(index-1);if(event.key==='ArrowRight')paint(index+1);});
    mobile.addEventListener('change',()=>{paint(0);start();});
    paint(0);start();
  });

  // Scratch offer
  const scratch=$('[data-scratch-offer]'), scratchScrim=$('[data-scratch-scrim]');
  if(scratch){
    const days=Number(scratch.dataset.frequency||7), delay=Number(scratch.dataset.delay||7000), last=Number(localStorage.getItem('unlabelledScratchSeen')||0), due=Date.now()-last>days*86400000;
    const canvas=$('[data-scratch-canvas]',scratch), zone=$('[data-scratch-zone]',scratch), copy=$('[data-copy-code]',scratch), code=$('[data-scratch-code]',scratch)?.textContent?.trim()||'';
    const coverColor=scratch.dataset.coverColor||'#b9b8b4', coverText=scratch.dataset.coverText||'SCRATCH HERE';
    let ctx, drawing=false, revealed=false, points=0;
    const close=()=>{scratch.classList.remove('is-open');scratch.setAttribute('aria-hidden','true');scratchScrim?.classList.remove('is-open');};
    const open=()=>{scratch.classList.add('is-open');scratch.setAttribute('aria-hidden','false');scratchScrim?.classList.add('is-open');localStorage.setItem('unlabelledScratchSeen',String(Date.now()));initCanvas();$('[data-scratch-close]',scratch)?.focus();};
    function initCanvas(){
      if(!canvas||!zone)return;
      const rect=zone.getBoundingClientRect(), dpr=Math.max(1,Math.min(2,devicePixelRatio||1));
      canvas.width=Math.round(rect.width*dpr); canvas.height=Math.round(rect.height*dpr); canvas.style.width=rect.width+'px'; canvas.style.height=rect.height+'px';
      ctx=canvas.getContext('2d'); ctx.scale(dpr,dpr); ctx.fillStyle=coverColor; ctx.fillRect(0,0,rect.width,rect.height); ctx.fillStyle='#111'; ctx.font='700 16px Arial'; ctx.textAlign='center'; ctx.textBaseline='middle'; ctx.fillText(coverText,rect.width/2,rect.height/2); ctx.globalCompositeOperation='destination-out'; ctx.lineCap='round'; ctx.lineJoin='round'; ctx.lineWidth=34;
    }
    function pos(e){const r=canvas.getBoundingClientRect();const p=e.touches?.[0]||e;return{x:p.clientX-r.left,y:p.clientY-r.top};}
    function start(e){drawing=true;const p=pos(e);ctx?.beginPath();ctx?.moveTo(p.x,p.y);e.preventDefault();}
    function move(e){if(!drawing||!ctx)return;const p=pos(e);ctx.lineTo(p.x,p.y);ctx.stroke();points++;if(points>32&&!revealed){revealed=true;copy.disabled=false;zone.classList.add('is-revealed');}e.preventDefault();}
    function end(){drawing=false;ctx?.closePath();}
    canvas?.addEventListener('pointerdown',start); canvas?.addEventListener('pointermove',move); window.addEventListener('pointerup',end);
    canvas?.addEventListener('touchstart',start,{passive:false}); canvas?.addEventListener('touchmove',move,{passive:false}); window.addEventListener('touchend',end);
    $$('[data-scratch-close]',scratch).forEach(b=>b.addEventListener('click',close)); scratchScrim?.addEventListener('click',close);
    copy?.addEventListener('click',async()=>{try{await navigator.clipboard.writeText(code);const original=copy.textContent;copy.textContent='COPIED';setTimeout(()=>copy.textContent=original,1500);}catch(e){copy.textContent=code;}});
    if(due)setTimeout(open,delay);
  }

  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeMenu();closeCart();closeQuick();}});
  refreshCart();
})();
